import Slide from '@mui/material/Slide';

export default function TransitionRight(props) {
  return <Slide {...props} direction="right" />;
}